export default function DemoVideoPlay({ url, onClose, alt }) {
    return (

        <div className="modal fade show" aria-modal="true" role="dialog" style={{ display: "block" }}>
            <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">&nbsp;</h5>
                        <button type="button" className="btn-close" onClick={onClose}></button>
                    </div>
                    <div className="modal-body d-flex" style={{ aspectRatio: 16 / 9 }} >
                        <iframe width="100%" height="480" src={url} alt={alt} allow="fullscreen;" data-gtm-yt-inspected-13="true">
                        </iframe>
                    </div>
                </div>
            </div>
        </div>
    )
}


